<template>
  <div id="app">
    <nav class="navbar navbar-expand-md navbar-dark fixed-top">
      <div class="container">
        <router-link
          class="nav-link active"
          aria-current="page"
          to="/"
          style="margin-left: 45px;color:white;"
          ><img src="@/assets/logo-white.png" class="logo" :alt="appTitle" />
          {{ appTitle }}</router-link
        >

        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarCollapse"
          aria-controls="navbarCollapse"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarCollapse">
          <ul class="navbar-nav me-auto mb-2 mb-md-0">
            <li class="nav-item" v-for="link in links" v-bind:key="link.url">
              <router-link
                :to="link.url"
                class="nav-link active"
                aria-current="page"
                v-if="isLoggedIn || link.allowAnonymous"
              >
                {{ link.text }}
                <svg
                  v-if="link.showIcon"
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-question-circle"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                  />
                  <path
                    d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"
                  />
                </svg>
              </router-link>
            </li>
          </ul>
          <div class="d-flex">
            <span v-if="currentUser" style="color:white;">
              {{ currentUser.firstname }} {{ currentUser.lastname }}</span
            >
            <a
              href="#"
              @click="logOut"
              style="margin-left: 15px; color:white;"
              v-if="currentUser"
              >Log ud</a
            >
          </div>
        </div>
      </div>
    </nav>

    <main class="container">
      <div class="p-5 rounded">
        <router-view />
      </div>
    </main>
  </div>
</template>

<script>
import AuthService from './services/auth.service';
export default {
  components: {},
  data: function() {
    return {
      appTitle: 'Valgberegner',
      links: [
        { text: 'Om', url: '/about', showIcon: false, allowAnonymous: true },
        { text: 'Hjælp', url: '/help', showIcon: true, allowAnonymous: false },
      ],
    };
  },
  computed: {
    isLoggedIn() {
      return this.currentUser !== undefined;
    },
    currentUser() {
      const userData = localStorage.getItem('user');

      if (userData) {
        const user = JSON.parse(userData);
        return user;
      }

      return undefined;
    },
  },
  methods: {
    logOut() {
      window.location = '/';
      AuthService.logout();
    },
  },
};
</script>
<style>
nav {
  background-color: #1f216b;
}

.logo {
  height: 22px;
}

body {
  padding-top: 4.5rem;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
